import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // <-- هذا هو مفتاح السحر الذي سيفعل التصميم
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);